module.exports = __webpack_public_path__ + "static/Twic-0ef1257dfb94c4cf2f6f124917a4a97b.jpg";